import { env } from "@/lib/environment";

export type CaseStudyCategory =
  | "all"
  | "corporate"
  | "retail"
  | "restaurant"
  | "transportation"
  | "education"
  | "banking"
  | "others";

export type CaseStudyCard = {
  href: string;
  image: { src: string; alt: string; width?: number; height?: number };
  title: string;
  category: CaseStudyCategory;
  description: string;
};

export const CASE_STUDIES: CaseStudyCard[] = [
  {
    href: "/case-studies/amazon-kiosk-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/amazon-ease/amazon.u-RBek-1miaC.webp`,
      alt:
        "Amazon using Pickcel's custom digital signage software in their kiosk placed across mall to manage product marketing easily.",
    },
    title: "Amazon",
    category: "retail",
    description:
      "How Amazon solved the product marketing challenge for Amazon mall-kiosks with Pickcel",
  },
  {
    href: "/case-studies/etisalat-telco-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/etisalat-telco/etisalat-index.eHQgC59xlKjR.webp`,
      alt: "Etisalat store offering digital signage solutions that is integrated with Pickcel",
    },
    title: "Etisalat",
    category: "retail",
    description:
      "Middle East's telco giant Etisalat delivers integrated digital signage to 12000+ SMBs through Pickcel's software & managed services",
  },
  {
    href: "/case-studies/mercedes-benz-corporate-communication",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/mercedes/mercedes-case-study.E6BdBju-R_4c.webp`,
      alt:
        "A Mercedes Benz car dealership showroom shows a partial view of a red hatchback car. A large Mercedes logo occupies the store exterior.",
    },
    title: "Mercedes-Benz",
    category: "corporate",
    description: "Mercedes-Benz ushers in new-age corporate communication with digital signage",
  },
  {
    href: "/case-studies/decathlon-sports-retail-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/decathlon-case-study.rDR1DNFEEY43.webp`,
      alt: "Decathlon sports retail store entrance view equipped with Pickcel-powered digital signage",
    },
    title: "Decathlon",
    category: "retail",
    description:
      "French sporting brand Decathlon brings down its customer acquisition cost with Pickcel digital signage",
  },
  {
    href: "/case-studies/third-wave-coffee-digital-menu-boards",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/third-wave-coffee/third-wave-coffee-card.2gVEpVZy8UQv.webp`,
      alt: "Third Wave Coffee store displaying digital menu boards powered by Pickcel",
    },
    title: "Third Wave Coffee",
    category: "restaurant",
    description: "How Third Wave Coffee rolled out digital menu boards across 700+ screens nationwide using Pickcel",
  },
  {
    href: "/case-studies/mcdonalds-digital-menu-boards",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/mc-donald/mc-donald-card.nowRXpUFslA_.webp`,
      alt: "McDonald's India restaurant showing digital menu boards powered by Pickcel",
    },
    title: "McDonald's India",
    category: "restaurant",
    description:
      "How McDonald's India centralized 1,300+ digital menu boards across a mixed Android and LG webOS fleet with Pickcel",
  },
  {
    href: "/case-studies/pepsico-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/pepsico-card-image.OQySxbsgQdn-.webp`,
      alt: "PepsiCo",
    },
    title: "PepsiCo",
    category: "others",
    description: "Vision In view: PepsiCo's communication leap with Pickcel",
  },
  {
    href: "/case-studies/arogya-ahaara-digital-menu",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/arogya-card.yMTyPyTnmDCe.webp`,
      alt:
        "aroy ahaara restaurant using Pickcel's custom digital signage software to manage their menus remotely",
    },
    title: "Arogya Ahaara",
    category: "restaurant",
    description:
      "Menu board automation: How Pickcel helped manage the Arogya Ahaara menus Remotely.",
  },
  {
    href: "/case-studies/novo-nordisk-and-pickcel-corporate-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/novo-nordisk/card-novo-nordisk.AgFBXUC-3OoR.jpg`,
      alt:
        "Novo Nordisk office displaying internal communications using Pickcel workplace digital signage",
    },
    title: "Novo Nordisk",
    category: "corporate",
    description:
      "Novo Nordisk Upgrades Internal Comms With Pickcel's Workplace Digital Signage",
  },
  {
    href: "/case-studies/the-bear-house-and-pickcel-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-bear-house.301QqS7tX3SZ.webp`,
      alt: "bear-house",
    },
    title: "Bear House",
    category: "retail",
    description: "The Bear House is a premium men’s fashion brand.",
  },
  {
    href: "/case-studies/nissan-motors-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/nissan-card.InGOAtTlXxR0.webp`,
      alt: "Nissan",
    },
    title: "Nissan Motor",
    category: "transportation",
    description: "How Nissan transformed dealership experiences with Pickcel digital signage.",
  },
  {
    href: "/case-studies/sa-ga-au",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/south-austrila.BFXdD9rH5PB5.webp`,
      alt: "South Australia's Government",
    },
    title: "Government of South Australia",
    category: "others",
    description: "Why did South Australia's Government choose Pickcel for secure digital signage?....",
  },
  {
    href: "/case-studies/analytixbusinesssolutions",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/analytics-card.vD5CL96Bp6z3.webp`,
      alt: "Analytix Solutions",
    },
    title: "Analytix Solutions",
    category: "corporate",
    description:
      "Streamlined communication and scalability: Analytix's digital signage success story...",
  },
  {
    href: "/case-studies/magnolia-bakery",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/magnoila-card.j0fNQttnJ3Nt.webp`,
      alt: "Magnolia Bakery",
    },
    title: "Magnolia Bakery",
    category: "restaurant",
    description:
      "Starting as a humble neighborhood bakery, today, Magnolia Bakery is an internationally recognized chain of bakeries...",
  },
  {
    href: "/case-studies/sokos",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/skoks-card.vExsg-GCgAph.webp`,
      alt: "skoks-card",
    },
    title: "SOKOS",
    category: "restaurant",
    description:
      "Simplifying menu boards and promotions: SOKOS transforming the digital & physical world",
  },
  {
    href: "/case-studies/urbanwrk",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/urban-card.dCABRehYeGgN.webp`,
      alt: "urbanWrk",
    },
    title: "Urbanwrk",
    category: "others",
    description:
      "Urbanwrk is known for its classic enterprise-managed shared workspaces. As a part of the URB Ventures....",
  },
  {
    href: "/case-studies/jw-marriott-hospitality-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/jm-marriot.HbyTi_wprnry.webp`,
      alt:
        "Hotel JW Marriott displaying content on digital signage screens with help of digital signage software from Pickcel",
    },
    title: "JW Marriott",
    category: "others",
    description:
      "How Hotel JW Marriott Enhanced Its Guest Experience With Pickcel's Cloud Digital Signage Solution",
  },
  {
    href: "/case-studies/nec-passenger-information-system",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/nec.Aegf0GM96qqO.webp`,
      alt:
        "Bus Stand equipped with NEC digital signage showing bus schedule with live feeds which is managed using Pickcel custom digital signage software.",
    },
    title: "NEC",
    category: "transportation",
    description:
      "How NEC built an intelligent passenger information system for 150 BRTS bus stops",
  },
  {
    href: "/case-studies/bridge-health-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/bridge-health-carecard.Axv0CYLdBFNy.webp`,
      alt: "bridgehealth",
    },
    title: "Bridge Health",
    category: "others",
    description:
      "Transforming healthcare communication: Bridge Health's success with Pickcel digital signage solutions",
  },
  {
    href: "/case-studies/general-dynamics",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/genreal-dynamics-card.1WCk7nRIQB28.webp`,
      alt: "General Dynamics Aerospace",
    },
    title: "General Dynamics",
    category: "others",
    description: "How General Dynamics used digital screens for real-time data insights.",
  },
  {
    href: "/case-studies/sapna-stores",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-sapna.U6ZqzueiDf-r.webp`,
      alt: "Sapna Book",
    },
    title: "Sapna Book House",
    category: "retail",
    description:
      "Sapna Book House turned to Pickcel, recognizing their decade-long expertise in the industry...",
  },
  {
    href: "/case-studies/ashjar-cafe",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-ashjar-cafe.ogQYzW0ql_8X.webp`,
      alt: "Ashjar Cafe Digital Menu Board",
    },
    title: "Ashjar Cafe",
    category: "restaurant",
    description: "How digital menu boards revamped customer engagement at Ashjar Cafe",
  },
  {
    href: "/case-studies/aarcorp-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-aar.BysRuaBPczoe.webp`,
      alt: "AARcorp's Digital Signage",
    },
    title: "AARcorp",
    category: "corporate",
    description:
      "Enhancing global communication in aviation: AARcorp's digital transformation with Pickcel...",
  },
  {
    href: "/case-studies/geewongers-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/geewongers-card.ZRCa6HUtEAr0.webp`,
      alt: "Geewongers Digital Signage",
    },
    title: "Geewongers",
    category: "retail",
    description:
      "Geewongers revolutionizes internal product promotion with Pickcel’s digital signage solution",
  },
  {
    href: "/case-studies/allergosan",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-allergosan.MxuDwg2pW3I7.webp`,
      alt: "Allergosan Digital Signage",
    },
    title: "Allergosan",
    category: "retail",
    description:
      "How Allergosan doubled their internal communication efficiency with Pickcel's digital signage solution",
  },
  {
    href: "/case-studies/digital-enlightenment-at-spiritual-place",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-sansthan.Z2rVILUL0CYl.webp`,
      alt: "Swami Narayan Temple Digital Signage",
    },
    title: "Swami Narayan Temple",
    category: "others",
    description:
      "Swami Narayan Temple is a gurukul established in the heart of Gujarat integrating modern signage solutions at spiritual sites",
  },
  {
    href: "/case-studies/iskcon-mumbai-solution",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-ickon.ZnIMLa87fVoy.webp`,
      alt: "International Society for Krishna Consciousness (ISKCON) Digital Signage",
    },
    title: "International Society for Krishna Consciousness (ISKCON)",
    category: "others",
    description:
      "The International Society for Krishna Consciousness (ISKCON), digital experience with ISKCON and Pickcel",
  },
  {
    href: "/case-studies/edutrack-display-dual-screen",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/edutrick-card.7XRV8HlFLg1X.webp`,
      alt: "Edutrack Digital Signage",
    },
    title: "Edutrack",
    category: "retail",
    description:
      "A story of dual screens - How Pickcel helped solve Edutrack displays' dilemma",
  },
  {
    href: "/case-studies/cardinal-glass-custom-app",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/cardinal-card.8eNiM7IVaCEW.webp`,
      alt: "Cardinal Corp Digital Signage",
    },
    title: "Cardinal Corp",
    category: "corporate",
    description:
      "Looking through the crystal glass of Cardinal Corp — apps and more",
  },
  {
    href: "/case-studies/netresponders",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/netresponders-solution.qlCKc_odUteE.webp`,
      alt: "NetResponders Digital Signage",
    },
    title: "NetResponders",
    category: "corporate",
    description:
      "NetResponders' integration with Pickcel's digital signage solutions",
  },
  {
    href: "/case-studies/ideawale-pan-india-solution",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/idewale-signange-card.ALeQGWa9TYjJ.webp`,
      alt: "Ideawale Digital Signage",
    },
    title: "Ideawale",
    category: "corporate",
    description:
      "Insuring ideas through screens - how Pickcel helped ideawale run Ad campaigns pan India",
  },
  {
    href: "/case-studies/hcl-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/hcl-card-imge.fa7gD1k_NrvF.webp`,
      alt: "HCLTech Digital Signage",
    },
    title: "HCLTech",
    category: "corporate",
    description:
      "Transforming communication: a digital signage revolution by HCLTech and Pickcel",
  },
  {
    href: "/case-studies/ffg-on-premise-solution",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/ffg-on-permsie-page-card.lB-QYdtGw-9H.webp`,
      alt: "FFG's Digital Signage",
    },
    title: "FFG",
    category: "corporate",
    description:
      "Optimizing in-house capabilities: FFG's on-premise solution journey",
  },
  {
    href: "/case-studies/gmrit",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/gmirt-college-card.AF7CD4xDZFj-.webp`,
      alt: "GMR Institute of Technology's",
    },
    title: "GMR Institute of Technology",
    category: "education",
    description:
      "A case study on GMR institute of technology's digital signage integration.",
  },
  {
    href: "/case-studies/jw-seafood",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/js-seafood-card.TMIeA0AR3tig.webp`,
      alt: "J&W Seafood's Digital Signage",
    },
    title: "J&W Seafood",
    category: "restaurant",
    description:
      "J&W seafood's transformation with digital menu innovation",
  },
  {
    href: "/case-studies/art-of-living",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/art-of-living-card-image._r0WTgtCOKAa.jpg`,
      alt: "Art of Living Digital Signage",
    },
    title: "Art of Living",
    category: "others",
    description:
      "Art of Living enhancing communication in spiritual spaces with Pickcel",
  },
  {
    href: "/case-studies/nestle-power-bi-dashboards",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/nestle-australia/banner.5u-3wqSvcY8f.webp`,
      alt: "Nestlé Australia Power BI dashboards on BrightSign floor screens",
    },
    title: "Nestlé Australia",
    category: "others",
    description:
      "SSO-secured Power BI and FourKites dashboards on BrightSign floor screens, running behind a strict corporate firewall..",
  },
  {
    href: "/case-studies/nicholson-manufacturing-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-image-nicholson.oF5fsAll9ujx.webp`,
      alt: "Nicholson Manufacturing Digital Signage",
    },
    title: "Nicholson Manufacturing",
    category: "others",
    description:
      "Nicholson Manufacturing, based in the USA, stands as a prominent player in the manufacturing sector. Known for their innovative approach..",
  },
  {
    href: "/case-studies/white-teak",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/whiteteak-card.127Ke86i29dd.webp`,
      alt: "White Teak Digital Signage",
    },
    title: "White Teak Company",
    category: "retail",
    description:
      "The White Teak company offers a diverse range of products, including decorative lighting, home decor, designer fans...",
  },
  {
    href: "/case-studies/tafaseel",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/tafaseel-card.02qPDg9uoimU.webp`,
      alt: "Tafaseel Digital Signage",
    },
    title: "Tafaseel",
    category: "banking",
    description:
      "Tafaseel and Pickcel: a partnership that boosted workplace morale and productivity.",
  },
  {
    href: "/case-studies/amrita-university",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/amirta-card.XVpcB_K7aImF.webp`,
      alt: "Amrita University Digital Signage",
    },
    title: "Amrita University",
    category: "education",
    description:
      "Pickcel's on-Premise solution: a game changer for Amrita University",
  },
  {
    href: "/case-studies/br-magazacilik",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/br-magazacilik.agV_LJjXVxBP.webp`,
      alt: "BR Magazacilik's Digital Signage",
    },
    title: "BR Magazacilik",
    category: "retail",
    description:
      "BR Magazacilik's digital breakthrough: scaling 100+ screens with Pickcel.",
  },
  {
    href: "/case-studies/namdhari-fresh",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/card-namdharis.VH5uCSHZYYaW.webp`,
      alt: "Namdhari Fresh Digital Signage",
    },
    title: "Namdhari Fresh",
    category: "retail",
    description:
      "Namdhari Fresh is a prominent name in the fresh produce industry, mainly known for...",
  },
  {
    href: "/case-studies/wam-global-events",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/wam-card.HX5rPHIS_9Q4.webp`,
      alt: "WAM Global Events Digital Signage",
    },
    title: "WAM Global Events",
    category: "others",
    description:
      "WAM Global Events, a Dubai-based company, excels in delivering unique event experiences...",
  },
  {
    href: "/case-studies/isdi",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/isdi-card.1Y9gRkqF7WHj.webp`,
      alt: "Indian School of Design and Innovation (ISDI) Digital Signage",
    },
    title: "Indian School of Design and Innovation (ISDI)",
    category: "education",
    description:
      "The Indian School of Design and Innovation (ISDI) is a in the field of design...",
  },
  {
    href: "/case-studies/taxplusinsurance",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/tax-pluscard.1EvS67wI8MHO.webp`,
      alt: "TaxPlus Insurance Digital Signage",
    },
    title: "TaxPlus Insurance",
    category: "banking",
    description:
      "TaxPlus Insurance com, an innovator in the financial sector, offers a broad spectrum of tax...",
  },
  {
    href: "/case-studies/brookefieldproperties",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/brookfield-card.2sxE3I1Ojysb.webp`,
      alt: "Brookfield Digital Signage",
    },
    title: "Brookfield Properties",
    category: "corporate",
    description:
      "Brookfield Properties, a premier global real estate services company, is renowned for its extensive...",
  },
  {
    href: "/case-studies/southwest-cannabis",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/southuwest-card.jYLzu1PhegUN.webp`,
      alt: "Southwest Cannabis Digital Signage",
    },
    title: "Southwest Cannabis",
    category: "retail",
    description:
      "Southwest Cannabis, a prominent name in the cannabis industry...",
  },
  {
    href: "/case-studies/chikkamagaluru-dcc-bank",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/ddc-Banking-card.BYFo0Vh-BTJN.webp`,
      alt: "Chikkamagaluru (DCC) Bank Digital Signage",
    },
    title: "Chikkamagaluru (DCC) Bank",
    category: "banking",
    description:
      "Chikkamagaluru District Cooperative Central (DCC) Bank, a prominent financial institution, serves a robust banking network.",
  },
  {
    href: "/case-studies/terrapay-corporate-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/terrapay.Jvi9amGSOcGx.webp`,
      alt: "TerraPay Digital Signage",
    },
    title: "TerraPay",
    category: "banking",
    description:
      "TerraPay is a global payment infrastructure company dedicated to delivering financial inclusion...",
  },
  {
    href: "/case-studies/dlf-mall-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/dlf-card.BFJ65qfXJQo0.webp`,
      alt: "DLF Mall Digital Signage",
    },
    title: "DLF Mall",
    category: "retail",
    description:
      "DLF Mall, situated in Noida, India, is a comprehensive shopping, dining, and entertainment hub. The arcade is divided into five unique ...",
  },
  {
    href: "/case-studies/automotive-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/yamaha-card.CvDzOEACIR-V.webp`,
      alt: "Yamaha Digital Signage",
    },
    title: "Yamaha",
    category: "transportation",
    description:
      "Yamaha, synonymous with innovative motorized products, forefront of engineering excellence for decades.",
  },
  {
    href: "/case-studies/honda",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/honda-card.zIHnGabU3VOK.webp`,
      alt: "Honda Digital Signage",
    },
    title: "Honda",
    category: "transportation",
    description:
      "Honda, a global powerhouse in the automobile and motorcycle industry, has always been at...",
  },
  {
    href: "/case-studies/asian-paints",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/asian-paint.hy2nspZUrQna.webp`,
      alt: "Asian Paints Digital Signage",
    },
    title: "Asian Paints",
    category: "retail",
    description:
      "How Asia’s third largest paint company, Asian Paints blended marketing with customer experience",
  },
  {
    href: "/case-studies/hindustan-unilever",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/unilever.-noFIY2iKIqI.webp`,
      alt: "Hindustan Unilever Digital Signage",
    },
    title: "Hindustan Unilever",
    category: "corporate",
    description:
      "How Hindustan Unilever offices galvanized internal communication & employee engagement",
  },
  {
    href: "/case-studies/hungerbox",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/hunger-box.teQJSr5NBd1I.webp`,
      alt: "HungerBox Digital Signage",
    },
    title: "HungerBox",
    category: "restaurant",
    description:
      "Popular food vendor aggregator HungerBox simplifies order queue management at corporate cafeterias with Pickcel",
  },
  {
    href: "/case-studies/curefit-cultfit-fitness-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/cure-fit.0n67R89AA4km.webp`,
      alt: "Cure fit gym equipped with digital signage displays that run on Pickcel's customized digital signage software",
    },
    title: "Cure.Fit & Cult.Fit Digital Signage",
    category: "corporate",
    description:
      "Cure.Fit (Offices) and Cult.Fit (Fitness Center/Gyms)— a story of digital signage bridging the communication gap",
  },
  {
    href: "/case-studies/varanasi-airport",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/vranasi.xqfd72je0bA2.webp`,
      alt: "Customer interacting with touchscreen kiosk at Varanasi Airport which is powered by Pickcel's custom digital signage software",
    },
    title: "Varanasi International Airport Digital Signage",
    category: "transportation",
    description:
      "The Varanasi International Airport steps up visitor engagement & simplifies information accessibility",
  },
  {
    href: "/case-studies/my-salon-suite-hair-salon-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/my-salon.vXF-4pXhCmEx.webp`,
      alt: "C&WJ employee interacting with customer.",
    },
    title: "Salon Suite Digital Signage",
    category: "corporate",
    description:
      "How the largest Salon Suite franchise in North America unified service promotion & customer engagement using Pickcel",
  },
  {
    href: "/case-studies/embassy-group-real-estate-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/embassy-case-study.n7xVhNfNA7Pc.webp`,
      alt: "Embassy Group Digital Signage",
    },
    title: "Embassy Group",
    category: "corporate",
    description:
      "Internal branding & real-time content streaming: how the Embassy Group aced it",
  },
  {
    href: "/case-studies/sirc-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/sirc-cardimage.igN9SykZclR0.webp`,
      alt: "Saudi Investment and Resource Company (SIRC) Digital Signage",
    },
    title: "Saudi Investment and Resource Company (SIRC) Digital Signage",
    category: "others",
    description:
      "Employee engagement streamlined: the story of Saudi Investment and Resource Company (SIRC) collaborating with Pickcel.",
  },
  {
    href: "/case-studies/panache-digital-photo-frame",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/panache.Jx8FGoY6yS65.webp`,
      alt: "Panache Digital Signage",
    },
    title: "Panache",
    category: "corporate",
    description:
      "Switzerland-based media consulting brand sparks up a buzz with creative digital photo frames",
  },

  {
    href: "/case-studies/accenture-and-pickcel-corporate-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/accenture-banner.RWSbxO5frTq1.webp`,
      alt: "Accenture Digital Signage",
    },
    title: "Accenture",
    category: "corporate",
    description:
      "Real-Time Flight Info for Accenture With Pickcel’s FIDS Solution",
  },
  {
    href: "/case-studies/exprezo-and-pickcel-retail-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/exprezo-banner.zTIrxIG1sDND.webp`,
      alt: "Exprezo Digital Signage",
    },
    title: "Exprezo",
    category: "retail",
    description:
      "Exprezo Fixed Inconsistent In-Store Messaging Across Outlets With Pickcel’s Digital Signage Solution",
  },
  {
    href: "/case-studies/saudi-ceramics-retail-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/saudi-ceramics-banner.AbO3bvEK9SJB.webp`,
      alt: "Saudi Ceramics Digital Signage",
    },
    title: "Saudi Ceramics",
    category: "retail",
    description:
      "Saudi Ceramics Redefined Their Customers’ Retail Experience Across 60+ Showrooms With Pickcel..",
  },
  {
    href: "/case-studies/vedantu-office-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/vendantu-banner.IGtwCK4Dzvsz.webp`,
      alt: "Vedantu Digital Signage",
    },
    title: "Vedantu",
    category: "education",
    description:
      "Vedantu Engages Students & Visitors NationWide Across 60+ Locations With Pickcel..",
  },



  {
    href: "/case-studies/cwjcu-finance-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/cwjcu-case-study.tQnvHt0Cfbe2.webp`,
      alt: "C&WJ employee interacting with customer.",
    },
    title: "C&WJ Digital Signage",
    category: "corporate",
    description:
      "Jamaican organization C&WJ adopts digital signage solution to upgrade its internal corporate communication",
  },
  {
    href: "/case-studies/fun-station-arcade-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/fun-station.FLSZ6UQFJEvr.webp`,
      alt: "Fun Station Arcade displaying content on digital signage screens with help of digital signage software from Pickcel",
    },
    title: "Fun Station Digital Signage",
    category: "retail",
    description:
      "Scotland-based fun station enriches the gaming experience with digital signage",
  },
  {
    href: "/case-studies/paralenz-retail-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/paralenz-img-2-min.hb3gbpBlPebX.webp`,
      alt: "Cafeteria equipped with a large digital signage tv screen displaying promotional message about coffee",
    },
    title: "Paralenz Digital Signage",
    category: "retail",
    description:
      "How Paralenz tackled the product marketing challenge across 100+ stores in Europe, US & Australia",
  },
  {
    href: "/case-studies/mad-and-co-qsr-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/mad-co.XYVBhf-dK2D8.webp`,
      alt: "Cafeteria equipped with a large digital signage tv screen displaying promotional message about coffee",
    },
    title: "Mad & Co Digital Signage",
    category: "restaurant",
    description:
      "How the popular beverage brand Mad & Co grew its business with Pickcel",
  },
  {
    href: "/case-studies/amazon",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/amazon-easy.JG9nCZoojpUT.webp`,
      alt: "Amazon Easy Store managing digital signage displays with help of custom digital signage software from Pickcel",
    },
    title: "Amazon Easy Digital Signage",
    category: "retail",
    description:
      "How Amazon Easy improved the customer experience across their ‘Easy Stores’ with Pickcel",
  },
  {
    href: "/case-studies/fmcg",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/fmcg.8LEuEfIDhPJr.webp`,
      alt: "FMCG Digital Signage ",
    },
    title: "FMCG",
    category: "retail",
    description:
      "How a popular FMCG company optimized advertisements to increase sales",
  },
  {
    href: "/case-studies/christ-university-education-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/christ-university.PP6LFxDHt5_U.webp`,
      alt: "Amazon using Pickcel's custom digital signage software in thier kiosk placed across mall to manage product marketing easily.",
    },
    title: "CHRIST University",
    category: "education",
    description:
      "How CHRIST University modernized their campuses using Pickcel's education digital signage software",
  },
  {
    href: "/case-studies/manipal",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/manipal.pOW71_-GfWB0.webp`,
      alt: "Manipal Hospitals equipped with digital signage managed by Pickcel's digital signage software to display hospital information.",
    },
    title: "Manipal Hospitals",
    category: "others",
    description:
      "Manipal Hospitals improved branding & internal communications with Pickcel",
  },
  {
    href: "/case-studies/hamlin-robinson-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/hamlin-school-card.va013vTi48s-.webp`,
      alt: "Hamlin Robinson Digital Signage",
    },
    title: "Hamlin Robinson",
    category: "education",
    description:
      "How Pickcel is crafting a digital future for Hamlin Robinson",
  },
  {
    href: "/case-studies/rs-brothers-retail-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/rs-brothers-card.AYgi92Iw-A1X.webp`,
      alt: "RS Brothers Digital Signage",
    },
    title: "RS Brothers",
    category: "retail",
    description:
      "Retail revolution: Pickcel's digital makeover for hyderabad-based RS Brothers",
  },
  {
    href: "/case-studies/train-advertising",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/ubn-card-train._zElSFKldmLJ.webp`,
      alt: "UBN Enterprise Digital Signage",
    },
    title: "UBN Enterprise",
    category: "transportation",
    description:
      "How UBN enterprise spearheaded intercity train advertising with Pickcel digital signage",
  },
  {
    href: "/case-studies/m3m-real-estate-digital-signage",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/m3m-index.61BdsRJc4mkp.webp`,
      alt: "M3M Digital Signage",
    },
    title: "M3M",
    category: "corporate",
    description:
      "Communications made simple: how Pickcel eased internal bottlenecks for M3M group",
  },
  {
    href: "/case-studies/cotton-patch",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/cotton-patch-card-image.S513DqhOLEm6.webp`,
      alt: "Cotton Patch Digital Signage",
    },
    title: "Cotton Patch",
    category: "restaurant",
    description:
      "How texas based restaurant chain Cotton Patch Cafe enhanced employee engagement and streamlined internal communication",
  },
  {
    href: "/case-studies/second-cup-digital-menu",
    image: {
      src: `${env.NEXT_PUBLIC_CDN_URL}/images/case-studies/case-study-card/second-cup-card-iamge.tZAhVas4lfKK.webp`,
      alt: "Second Cup Coffee Digital Signage",
    },
    title: "Second Cup Coffee",
    category: "restaurant",
    description:
      "How Pickcel helped Second Cup coffee streamline their menu management and branding across franchisees",
  },
];


